<template>
  <modal @close="$emit('closed')" aria-live="assertive" close-btn tabindex="0">
    <template v-if="selectedReservations.length > 0">
      <template slot="body" class="p-5">
        <div class="row">
          <div class="col-12">
            <div v-if="date_message">{{ $t("my_bookings.date_required") }}</div>
            <label for="data_ripetizione">{{
              $t("my_bookings.data_input")
            }}</label>
            <div class="input-group mb-3 w-100">
              <div
                class="input-group-prepend"
                :style="start_time ? 'width: 95%' : 'width:100%'"
              >
                <input
                  type="text"
                  ref="input"
                  v-model="start_time"
                  id="data_ripetizione"
                  required
                />
              </div>
              <div class="input-group-append">
                <span
                  @click="resetDatePicker"
                  @keypress.enter="resetDatePicker"
                  v-if="start_time"
                  role="button"
                  class="reset-date"
                  tabindex="0"
                >
                  <span class="sr-only">resetta</span>
                  <i class="fas fa-times"></i>
                </span>
              </div>
            </div>
          </div>

          <e-button
            @click="confirm"
            :disabled="!start_time || start_time == ''"
            @keypress.enter="confirm"
            >Conferma</e-button
          >
        </div>
      </template>
    </template>
    <template v-else>
      <template slot="body">
        {{ $t("my_bookings.select_one") }}
      </template>
    </template>
  </modal>
</template>

<script>
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css";
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.it.min.js";
import $ from "jquery";

export default {
  props: {
    selectedReservations: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    const vm = this;
    this.datePicker = $(this.$refs.input);

    this.datePicker
      .datepicker({
        multidate: true,
        startDate: "+1d",
        format: "dd/mm/yyyy",
        language: this.lang,
      })
      .on("changeDate", function () {
        vm.updateStartTime(vm.datePicker.val());
      });
  },

  data() {
    return {
      savedReservations: [],
      start_time: "", // Inizialmente vuoto
      datePicker: null,
      date_message: false,
    };
  },
  methods: {
    resetDatePicker() {
      this.start_time = "";
      this.datePicker.datepicker("update", "");
    },
    updateStartTime(val) {
      this.start_time = val;
    },
    async confirm() {
        if (this.start_time === "" || !this.start_time) {
            this.date_message = true;
            return;
        }

        const dateParts = this.start_time.split(",");
        const allResults = [];

        try {
            for (const reservation of this.selectedReservations) {
                for (const datePart of dateParts) {
                    try {
                    const res = await this.$http.post(`/api/entry/ripeti/${reservation.repeat_id}`, {
                        start_time: datePart,
                    });

                    // salviamo ogni prenotazione riuscita
                    this.savedReservations.push({
                        codice: res.data.codice_prenotazione,
                        primaria: res.data.public_primaria,
                    });

                    allResults.push({ success: true, reservation: res.data });
                    } catch (error) {
                        console.error("Prenotazione fallita:", error);
                        allResults.push({ success: false, error, reservation });
                    }
                }
            }

            const someFailed = allResults.some(r => !r.success);

            if (someFailed) {
                console.warn("Alcune prenotazioni non sono riuscite. Avvio rollback.");
                for (let entry of this.savedReservations) {
                    console.log("Elimino:", entry);
                    this.elimina(entry.codice, entry.primaria);
                }
                const prenotazioniFallite = allResults.filter(result => result.success == false).map(result => result.reservation.codice);
                this.setError(
                    {
                        count: prenotazioniFallite.length,
                        data: {codici: prenotazioniFallite.join(', ')},
                        message: 'server.errors.errore_multi_prenotazione',
                    }
                );
            } else {
                allResults.forEach(async (result) => {
                    const reservation = result.reservation;
                    await this.$http.post(`/api/entry/confirm/${reservation.entry}`);
                })
                this.setMessage({
                    name: "effettuata",
                    message: "Prenotazioni effettuate con successo",
                });

                this.$emit("updated");
            }
        } catch (e) {
            console.error("Errore generale:", e);
        } finally {
            this.$emit("closed");
        }
    },

    elimina(codice, primaria) {
        console.log('elimino: '+ codice);
      this.$http
        .post(`api/entry/delete/${codice}?chiave=${primaria}`, {
          force: true,
        })
        .catch((e) => {
          this.setError(e);
        });
    },
  },
};
</script>
